import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateJobSeekerProfileResumeLocationMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeInput;
}>;


export type UpdateJobSeekerProfileResumeLocationMutation = { __typename?: 'Mutation', updateJobSeekerProfileResume?: { __typename?: 'UpdateJobSeekerProfileResumePayload', resume?: { __typename?: 'JobSeekerProfileResume', id: string, location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, admin1?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null } | null } | null };


export const UpdateJobSeekerProfileResumeLocationDocument = gql`
    mutation UpdateJobSeekerProfileResumeLocation($input: UpdateJobSeekerProfileResumeInput!) {
  updateJobSeekerProfileResume(input: $input) {
    resume {
      id
      location {
        address
        admin1
        city
        country
        state
        postalCode
        formattedLocation
        latitude
        longitude
        geocodePrecision
      }
    }
  }
}
    `;
export type UpdateJobSeekerProfileResumeLocationMutationFn = Apollo.MutationFunction<UpdateJobSeekerProfileResumeLocationMutation, UpdateJobSeekerProfileResumeLocationMutationVariables>;

/**
 * __useUpdateJobSeekerProfileResumeLocationMutation__
 *
 * To run a mutation, you first call `useUpdateJobSeekerProfileResumeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSeekerProfileResumeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSeekerProfileResumeLocationMutation, { data, loading, error }] = useUpdateJobSeekerProfileResumeLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSeekerProfileResumeLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobSeekerProfileResumeLocationMutation, UpdateJobSeekerProfileResumeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobSeekerProfileResumeLocationMutation, UpdateJobSeekerProfileResumeLocationMutationVariables>(UpdateJobSeekerProfileResumeLocationDocument, options);
      }
export type UpdateJobSeekerProfileResumeLocationMutationHookResult = ReturnType<typeof useUpdateJobSeekerProfileResumeLocationMutation>;
export type UpdateJobSeekerProfileResumeLocationMutationResult = Apollo.MutationResult<UpdateJobSeekerProfileResumeLocationMutation>;
export type UpdateJobSeekerProfileResumeLocationMutationOptions = Apollo.BaseMutationOptions<UpdateJobSeekerProfileResumeLocationMutation, UpdateJobSeekerProfileResumeLocationMutationVariables>;